import React from "react";
import ReactDOM from "react-dom";
import {createBrowserHistory} from "history";
import {Router, Route, Switch, Redirect} from "react-router-dom";

import "assets/scss/material-kit-pro-react.scss?v=1.9.0";
import storage from "./utils/storage";

import Login from "./views/login"
import SignUp from "./views/signUp"
import Welcome from "./views/welcome"
import NoMatchError from "./views/error"
import Plans2 from "./views/plans_2"
import Series from "./views/series"
import SeriesInfo from "./views/series_info"
import ScrollToTop from "./views/BaseView/ScrollToTop";
import Video from "./views/video";
import Account from "./views/Account";
import Mockingbird from "./views/mockingbird"
import EmailAttest from "./views/email_attest";
import PasswordForget from "./views/password_forget";
import PasswordSet from "./views/password_set";
import RegisteredCheck from "./views/registered_check";
import CreatePay2 from "./views/create_pay_2";
// import CreatePayOnly from "./views/create_pay_only";
import InPay from "./views/in_pay";
import InPayOnly from "./views/in_pay_only";
import AboutUs from "./views/mine";
import AboutUsOnly from "./views/mine_only";
import MockingbirdOnly from "./views/mockingbird_only"
import AndroidDownload from "./views/android_download"
import intl from 'react-intl-universal';
import cookie from "react-cookies";

// locale data
const locales = {
	"en-US": require('./locales/en-US.json'),
	"zh-CN": require('./locales/zh-CN.json'),
};

var hist = createBrowserHistory();

class App extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isPc: true,
			initDone: false
		};

		let ua = navigator.userAgent;

		let isWindowsPhone = /(?:Windows Phone)/.test(ua),
			isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
			isAndroid = /(?:Android)/.test(ua),
			isFireFox = /(?:Firefox)/.test(ua),
			isChrome = /(?:Chrome|CriOS)/.test(ua),
			isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
			isPhone = /(?:iPhone)/.test(ua) && !isTablet,
			isPc = !isPhone && !isAndroid && !isSymbian;
		this.state.isPc = isPc;

		storage.set("isPC", this.state.isPc)
	}

	// 支持动态切换语言
	changeLanguage = (lang) => {
		let inOneYear = new Date(new Date().getTime() + 24 * 3600 * 1000 * 365);
		cookie.save('lang', lang, {expires: inOneYear, path: '/'});
		this.setState({initDone: false}, () => {
			this.loadLocales(lang);
		});
	}

	componentDidMount() {
		this.loadLocales();
	}

	loadLocales(langParam) {
		let lang = langParam;
		if (!lang) {
			lang = cookie.load('lang');
		}
		if (!lang) {
			const language = window.navigator.language.toLowerCase();
			if (language === 'zh-cn') {
				lang = 'zh-CN';
			} else {
				lang = 'en-US';
			}
		}
		let inOneYear = new Date(new Date().getTime() + 24 * 3600 * 1000 * 365);
		cookie.save('lang', lang, {expires: inOneYear, path: '/'});
		let currentLocale = lang;
		intl.init({
			currentLocale,
			locales,
		}).then(() => {
			this.setState({initDone: true});
		});
	}

	render() {
		return (
			this.state.initDone &&
			<Router history={hist}>
				<ScrollToTop>
					<Switch>
						<Redirect from='/' exact to='/welcome'/>

						<Route path='/welcome/:utm' component={Welcome}/>
						<Route path='/welcome' component={Welcome}/>
						<Redirect from='/utm/:utm' exact to='/welcome/:utm'/>

						<Route path='/login/:tips' component={Login}/>
						<Route path="/login" component={Login}/>
						<Route path="/email_re_attest" component={EmailAttest}/>
						<Route path='/registered_check/:key' component={RegisteredCheck}/>
						<Route path="/password_forget" component={PasswordForget}/>
						<Route path="/password_set/:key" component={PasswordSet}/>

						{/*<Route path='/create_pay/:planId/:token' component={CreatePayOnly}/>*/}
						<Route path='/create_pay' component={CreatePay2}/>
						{/*<Redirect from='/create_pay' exact to='/welcome'/>*/}

						<Route path='/in_pay/:type/:orderId/:token' component={InPayOnly}/>
						<Route path='/in_pay/:type/:orderId' component={InPay}/>
						<Redirect from='/in_pay' exact to='/welcome'/>
						<Redirect from='/in_pay/:type' exact to='/welcome'/>

						<Route path="/signUp" component={SignUp}/>
						<Route path="/about/only" component={AboutUsOnly}/>
						<Route path="/about" component={AboutUs}/>
						<Route path="/plans" component={Plans2}/>
						<Route path="/series" component={Series}/>
						<Route path="/series_info/:id" component={SeriesInfo}/>
						<Route path="/video" component={Video}/>
						<Route path="/account" component={Account}/>
						<Route path="/mockingbird_only/:id/:token" component={MockingbirdOnly}/>
						<Redirect from='/mockingbird_only/:id' exact
								  to='/mockingbird_only/:id/clwater'/>
						<Route path="/mockingbird/:id/:token" component={MockingbirdOnly}/>
						<Route path="/mockingbird/:id" component={Mockingbird}/>


						<Route path="/androidDownload" component={AndroidDownload}/>

						<Route path="/error" component={NoMatchError}/>
						<Route path="/404" component={NoMatchError}/>


						<Route component={NoMatchError}/>
					</Switch>
				</ScrollToTop>
			</Router>
		)
	}
}

export default App
